import { render, staticRenderFns } from "./StdPrescription.vue?vue&type=template&id=284031aa"
import script from "./StdPrescription.vue?vue&type=script&lang=js"
export * from "./StdPrescription.vue?vue&type=script&lang=js"
import style0 from "./StdPrescription.vue?vue&type=style&index=0&id=284031aa&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284031aa')) {
      api.createRecord('284031aa', component.options)
    } else {
      api.reload('284031aa', component.options)
    }
    module.hot.accept("./StdPrescription.vue?vue&type=template&id=284031aa", function () {
      api.rerender('284031aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/StdPrescription.vue"
export default component.exports